/**
 * Recipient reachability helpers of the sponsored wizard. The delivery channel
 * is an explicit brand choice on the channel step (the automatic prediction was
 * retired with it); these helpers only answer "can this line be delivered at
 * all" and "is this a mono send".
 */

/** A recipient line the wizard reads (only the delivery-relevant fields). */
export interface DeliveryRecipient {
  email: string | null;
  creatorIdentityId: string | null;
}

/** Whether a recipient can be delivered at all (has an identity or an email). */
export const isReachable = (recipient: DeliveryRecipient): boolean =>
  recipient.creatorIdentityId !== null || recipient.email !== null;

/**
 * True when the send targets exactly one reachable recipient — the only case
 * where mono-only signals (open Instagram conversation, single known email)
 * refine the channel options.
 */
export const isMonoSend = (recipients: readonly DeliveryRecipient[]): boolean =>
  recipients.length === 1 && isReachable(recipients[0]);
